<template>
    <el-container class="main-content">
        <TopNav />
        <el-container v-loading="!ready">
            <el-container>
                <el-main>
                    <router-view v-if="ready" />
                </el-main>
                <!-- <Footer /> -->
            </el-container>
        </el-container>
    </el-container>
</template>

<script>
import TopNav from '../widgets/TopNav.vue';
import SideNav from '../widgets/SideNav.vue';
import Footer from '../widgets/Footer.vue';

export default {
    components: {
        TopNav,
        // Footer,
    },
    data() {
        return {
            mode: process.env.VUE_APP_APPLICATION_MODE,
            ready: true,
        };
    }
};
</script>

<style scoped lang="scss">
.main-content {
    padding-top: 80px;
}
</style>
